import { useEffect, useState } from "react";

export function useFile(url: string | undefined, transform: (x: any) => any = (x) => x, error: null | ((x: any) => void) = null) {
  const [loading, setLoading] = useState(true);
  const [file, setFile] = useState<any>();
  useEffect(() => {
    // e.g. a staff member without a floor plan: nothing to fetch
    if (!url) {
      return;
    }
    fetch(url)
      .then(transform, error)
      .then(data => {
        setFile(() => {
          setLoading(false);
          return data;
        });
      }, error);
  }, [url]);
  return [file, loading];
}
